import Modal from "../../UI/Modal";
import { useSelector, useDispatch } from "react-redux";
import { closeAreaViewModal } from "../../../store/reducers/fortalezas/fortalezasPlantel.reducer";
import Loader from "../../UI/Loader";
import Field from "../../UI/Field";
import AuditInfo from "../../UI/AuditInfo";

const AreaViewModalPlantel = () => {
  const dispatch = useDispatch();
  const { areaViewModalOpen, selectedArea, selectedAreaLoading, selectedAreaError } = useSelector((state) => state.fortalezasPlantel);

  return (
    <Modal open={areaViewModalOpen} onClose={() => dispatch(closeAreaViewModal())} title="Detalle del área" size="lg">
      {selectedAreaLoading && <Loader center text="Cargando..." delay={150} type="dots" />}
      {selectedAreaError && <p className="text-danger">{selectedAreaError}</p>}
      {!selectedAreaLoading && selectedArea && (
        <div className="row g-4">
          <div className="col-12"><Field icon="mdi:shape-outline" label="Área" value={selectedArea.area} justify /></div>
          {selectedArea.descripcion && <div className="col-12"><Field icon="mdi:description" label="Descripción" value={selectedArea.descripcion} justify /></div>}
          <div className="col-12">
            <Field icon="mdi:toggle-switch" label="Estado" value={
              <span className={`badge ${selectedArea.is_active ? "bg-success-focus text-success-main" : "bg-neutral-200 text-neutral-600"} px-3 py-2`}>
                {selectedArea.is_active ? "Activa" : "Inactiva"}
              </span>
            } />
          </div>
          <div className="col-12"><AuditInfo createdAt={selectedArea.created_at} updatedAt={selectedArea.updated_at} createdBy={selectedArea.created_by} updatedBy={selectedArea.updated_by} /></div>
        </div>
      )}
    </Modal>
  );
};

export default AreaViewModalPlantel;
